/* eslint-disable max-len */
import { React, Fragment, useState, useContext, useRef } from 'react'
import Pagination from '../../../../components/Pagination';
import { dataService } from '../../../../services/data.services';
import { GetBranchId } from '../../../../CommonMethods/GetBranchId';
import GlobalContext from '../../../../components/Context/GloablContext';
import Loader from '../../../../components/Loader';
import { formatAdjustedDate } from '../../../../CommonMethods/formatDate';
import AnimatedButton from '../../../../components/Animation/AnimatedButton';
import { useNavigate } from 'react-router-dom';
import { useOnClickOutside } from '../../../../CommonMethods/OutsideClick';

const Table = ({feeCollectionStudentList,
    searchParams, 
    setSearchParams,  
    setPageLoading, 
    reportTotal,
    handleOnClickSort,sortValue,
    startDate,
    endDate,
    indexNum,
    tableData,
    feeCollectionStudentCount}) => {
    const navigate = useNavigate();
    const [dotLoader, setDotLoader] = useState(null)
    const [selectedIndex, setSelectedIndex] = useState(null);
    const [downloadLoading, setDownloadLoading] = useState(false);
    const selectedRef = useRef(null);
    const { setToastErrorMessage, setToastmessage } = useContext(GlobalContext);
    const urlParams = new URLSearchParams(window.location.search);

    const branchUrl = urlParams.get("sort");

    useOnClickOutside(selectedRef, () => {
        setSelectedIndex(null)
    });
    /**
     * The function `handleOnClickPageNumber` updates the search parameters with a new page number and sets
     * the page loading state to true.
     */
    const handleOnClickPageNumber = (pageNum) => {
        setPageLoading(true);
        const params = Object.fromEntries(searchParams) 
        setSearchParams({ ...params, page_number: pageNum.selected + 1 })
    }
    const handleSort = (key) => {
        if(sortValue === '') handleOnClickSort('sort', `${key}+asc`)
        else {
            if(sortValue.includes(key)) handleOnClickSort('sort', `${key}+${sortValue.includes('+desc') ? 'asc' : 'desc'}`)
            else handleOnClickSort('sort', `${key}+asc`)
        }
    }
    const handelActionButton = (index) => {
        setSelectedIndex(index === selectedIndex ? null : index);
    };
    
    /**
     * The function `handleFileDownload` is used to download a fee receipt by making an API call and
     * opening the pre-signed URL in a new window.
     */
    const handleFileDownload = async (fee, index) => {
        setDotLoader(index)
        try {
            const branch_id = await GetBranchId();
            const res = await dataService.GetAPI(`collect-fees/download/${fee?._id}/${branch_id}`)
            window.open(res.data.data.pre_signed_url, '_blank');
            setToastmessage("Fee Receipt downloaded successfully");
        } catch (error) {
            console.error('An error occurred:', error);
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong");
        } finally{
            setDotLoader(null) 
        }
    }
    return(
        <div class="">
            <div class="-mx-1">
                <div className='text-center absolute w-full'>Collection Date from <span className="font-semibold">{searchParams?.get('start_date') === null ?  formatAdjustedDate(startDate) : formatAdjustedDate(searchParams?.get('start_date'))}</span> to <span className="font-semibold">{searchParams?.get('end_date') === null ?  formatAdjustedDate(endDate, true) : formatAdjustedDate(searchParams?.get('end_date'))}</span></div>
                <div class={`flex overflow-hidden scroll-bar px-1 topHeading ${feeCollectionStudentList?.length < 8 ? 'pb-[62px]' : 'pb-[6px]'}`} id="search-result">
                    <table aria-label="Outside Table" class="w-full" id="admin-table">
                        <thead>
                            <tr>
                                <th id="Received Date" class="w-[10%]" onClick={() => {handleSort('received_date')}}>
                                    <span >Received Date
                                        <button type="button" class="pl-1.5 sortedIcon">
                                            <img loading="lazy" decoding="async" src={branchUrl !== undefined && branchUrl?.split("+")[0] === "received_date" ? branchUrl?.split("+")[1] === "asc" ? "/images/sortAsc.svg" : "/images/sortDesc.svg" : "/images/Vector.svg"} alt="icon"/>
                                        </button>
                                    </span>
                                </th>
                                <th id="Student Name" class="w-[22%]" onClick={() => {handleSort('student_name')}}>
                                    <span >Student Name
                                        <button type="button" class="pl-1.5 sortedIcon">
                                            <img loading="lazy" decoding="async" src={branchUrl !== undefined && branchUrl?.split("+")[0] === "student_name" ? branchUrl?.split("+")[1] === "asc" ? "/images/sortAsc.svg" : "/images/sortDesc.svg" : "/images/Vector.svg"} alt="icon"/>
                                        </button>
                                    </span>
                                </th>
                                <th class="w-[12%]">
                                    <span >Class, Section
                                    </span>
                                </th>
                                <th id="Receipt Number" class="w-[10%]" onClick={() => {handleSort("receipt_number");}}>
                                    <span >Receipt #
                                        <button type="button" class="pl-1.5 sortedIcon">
                                            <img loading="lazy" decoding="async" src={branchUrl !== undefined && branchUrl?.split("+")[0] === "receipt_number" ? branchUrl?.split("+")[1] === "asc" ? "/images/sortAsc.svg" : "/images/sortDesc.svg" : "/images/Vector.svg"} alt="icon"/>
                                        </button>
                                    </span>
                                </th>
                                <th class="w-[12%]">
                                    <span class="flex items-center justify-end">Collection Amount
                                    </span>
                                </th>
                                <th class="w-[10%]">
                                    <span class="flex items-center justify-center">Actions
                                    </span>
                                </th>
                            </tr>
                            <tr aria-colspan="7" class="h-1"></tr>
                        </thead>
                        <tbody >
                            {feeCollectionStudentList?.map((fee, index = 0) => (
                                <>
                                    <tr id="list-items" aria-colspan="7" class="relative h-0.5 z-[-10]"></tr>
                                    <tr class="group cursor-pointer" onClick={(e) => {
                                        if (e.target.classList.contains('prevent-click')) {
                                            return;
                                        }
                                        const encodedId = encodeURIComponent(fee._id);
                                        navigate(`/student-master/fee-collection/fee-collection-details/${encodedId}`);
                                        setSelectedIndex(null); }}>
                                        <td class="text-start">{formatAdjustedDate(fee?.received_date)}</td>
                                        <td class="text-start">{fee?.student_name+' ['+fee?.student_id+']'}</td>
                                        <td class="text-start">{fee?.class_name+', '+fee?.section_name}</td>

                                        <td class="text-start  capitalize">{fee?.receipt_number}</td>
                                        <td class="text-end">{parseFloat(fee?.received_amount).toFixed(2)}</td>
                                        <td className="cursor-pointer prevent-click">
                                            <div className="relative flex items-center justify-center prevent-click" data-te-dropdown-position="dropstart">
                                                <button
                                                    type="button"
                                                    className="list-more-btn prevent-click"
                                                    id={'3dot'+index}
                                                    onClick={() => handelActionButton(index)}
                                                    data-te-dropdown-toggle-ref
                                                    aria-expanded="false"
                                                    data-te-ripple-init
                                                    data-te-ripple-color="light"
                                                >
                                                    <img loading="lazy" decoding="async" src="/images/listAction.svg" alt="icon" className="prevent-click" />
                                                </button>
                                                {selectedIndex === index && (
                                                    <ul
                                                        ref={selectedRef}
                                                        className={`${(index+1 === 10 || index+2 === 10) ? 'top3' : ''} list-more-optns-div [&[data-te-dropdown-show]]:block prevent-click z-50`}
                                                        aria-labelledby="dropdownMenuButton2"
                                                        data-te-dropdown-menu-ref
                                                    >
                                                        <li>
                                                            <AnimatedButton
                                                                handleClick={() => {
                                                                    const encodedId = encodeURIComponent(fee._id);
                                                                    navigate(`/student-master/fee-collection/fee-collection-details/${encodedId}`);
                                                                    setSelectedIndex(null);
                                                                }}
                                                                buttonName="View Details"
                                                                id="view_invoice"
                                                                className="list-more-optns prevent-click"
                                                            />
                                                        </li>
                                                        <li>
                                                            <AnimatedButton
                                                                handleClick={() => handleFileDownload(fee, index)}
                                                                buttonName="Download"
                                                                id="download_invoice"
                                                                className="list-more-optns prevent-click"
                                                                loading={downloadLoading}
                                                            />
                                                        </li>
                                                    </ul>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                </>))}
                            {feeCollectionStudentCount !== 0 && (
                                <>
                                    <tr id="list-items" aria-colspan="7" class="relative h-0.5 z-[-10]"></tr>
                                    <tr class="group rounded-[16px]">
                                        <td class="font-semibold text-start  rounded-tl-[16px] rounded-bl-[16px] border-[#C2DCEF] break-all" colSpan={4}>
                                            <p>Report Total</p>
                                        </td>
                                        <td class="pl-3 pr-6 py-[15px] text-f2 text-[#031624] font-semibold text-end" colSpan={1}>
                                            <p>{parseFloat(reportTotal).toFixed(2)}</p>
                                        </td>
                                        <td className="font-semibold text-start   border-[#C2DCEF]  "></td>
                                    </tr></>)}
                        </tbody>
                        {feeCollectionStudentCount === 0 && (
                            <tbody>
                                <tr>
                                    <td style={{ 'line-height': '100px' }} colspan="6" className="no-records-message" id='no-matching-result'>
                                        {'No records found'}
                                    </td>
                                </tr>
                            </tbody>
                        )}
                    </table>
                </div>
                {feeCollectionStudentCount > 10 &&  <Pagination
                    TotalCount={feeCollectionStudentCount}
                    totalPageNumber={Math?.ceil(feeCollectionStudentCount / 10)}
                    selectedPageNumber={Number(searchParams.get('page_number')) || 1}
                    handleOnClickPageNumber={handleOnClickPageNumber}
                />}
            </div>
        </div>
    )
}
export default Table;   